export default "<nz-progress [nzPercent]=\"time\" nzType=\"circle\"></nz-progress>\n"